import XmlDomUtils from '../../../utils/XmlDomUtils';
import interactionParserUtils from './InteractionParserUtils';
import stringUtils from '../../../utils/StringUtils';

const inlineChoiceParser = {
    parse(interactionElement, language, defaultLanguage) {
        const attributes = XmlDomUtils.getAttributes(interactionElement);
        let alternatives = interactionParserUtils.parseListOfChildren(interactionElement, 'inlineChoice', language, defaultLanguage);

        if (alternatives.length === 0) {
            // TODO TESTC-6037 as the inline choice output from IA is wrong, we temporary have to support the wrong format
            alternatives = interactionParserUtils.parseListOfChildren(interactionElement, 'simpleChoice', language, defaultLanguage);
        }
        const interactionType = attributes['inspera:type'];
        const hasHorizontalRender = attributes['inspera:horizontalRender'] === 'true' || false;
        const hasGranularNumbering = attributes['inspera:granularNumbering'] === 'true' || false;
        const shuffle = attributes.shuffle === 'true';

        alternatives.forEach((alternative) => {
            alternative.content = stringUtils.unescapeXML(alternative.content);
        });

        return {
            alternatives,
            interactionType,
            shuffle,
            hasHorizontalRender,
            hasGranularNumbering,
        };
    },
};

export default inlineChoiceParser;
